module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0001.e0d25939.jpg";